import AgentProfileForm from '@/components/AgentProfileForm';
import ClientAddForm from '@/components/ClientAddForm';
import ClientCsvUpload from '@/components/ClientCsvUpload';
import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MyDashboard from './MyDashboard';
import { useState } from 'react';
import ImportedDataView from '@/components/ImportMapping/ImportedData';
import { useSearchParams } from 'react-router-dom';

const AgentDashboard = () => {
  const [query] = useSearchParams();
  const [isUpload, setIsUpload] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-1">
        <div className="flex items-center space-x-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-tax-deepBlue">
              Agent Dashboard
            </h1>
            <p className="text-tax-neutralGray">
              Manage your profile and clients
            </p>
          </div>
        </div>

        <Tabs
          defaultValue={query.get('tab') ?? 'profile'}
          className="space-y-4"
        >
          <TabsList className="border-b w-full justify-start rounded-none bg-transparent p-0">
            <TabsTrigger
              value="profile"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Profile
            </TabsTrigger>
            <TabsTrigger
              value="clients"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Clients
            </TabsTrigger>
            <TabsTrigger
              value="reports"
              className="rounded-t-lg data-[state=active]:border-b-2 data-[state=active]:border-tax-actionOrange data-[state=active]:bg-white data-[state=active]:shadow-none px-4 py-2"
            >
              Reports
            </TabsTrigger>
          </TabsList>

          <TabsContent value="profile" className="space-y-4">
            <AgentProfileForm />
          </TabsContent>

          <TabsContent value="clients" className="space-y-4">
            <div className="">
              {/* <ClientAddForm /> */}
              {isUpload ? (
                <ClientCsvUpload onBackToList={() => setIsUpload(false)} />
              ) : (
                <ImportedDataView onImportData={() => setIsUpload(true)} />
              )}
            </div>
          </TabsContent>

          <TabsContent value="reports" className="space-y-4">
            <MyDashboard tableOnly />
          </TabsContent>
        </Tabs>
      </div>
      <Footer />
    </div>
  );
};

export default AgentDashboard;
